import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from './../../../../core/toast.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GetDentalSuppliersService } from '../../services/get-dental-suppliers.service';
import { AddSupplierAccountRequestService } from '../../services/add-supplier-account-request.service';

@Component({
  selector: 'app-add-supplier-account-request',
  templateUrl: './add-supplier-account-request.component.html',
  styleUrls: ['./add-supplier-account-request.component.scss']
})
export class AddSupplierAccountRequestComponent implements OnInit {
  /* --------------------------------- FIELDS -------------------------------- */
  dentalSupplierList: any[];
  supplierAccountRequestPayForm =  this._fb.group ({
    supplier_id: [null, Validators.required],
    name: [null, [Validators.required]],
    email: [null, [Validators.required]],
    phone: [null, [Validators.required]]
  });
  /* ------------------------------- CONSTRUCTOR ------------------------------ */
  constructor(
    private _dialogRef: MatDialogRef<AddSupplierAccountRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: null,
    private _fb: FormBuilder,
    private getDentalSuppliersService: GetDentalSuppliersService,
    private addSupplierAccountRequestService : AddSupplierAccountRequestService,
    private toast: ToastService,
    private spinner: NgxSpinnerService
  ) { }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit() {
    this.getDentalSuppliersService.getDentalSuppliers().subscribe(dentalSupplierList=>{
      this.dentalSupplierList = dentalSupplierList;
    })
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  closeDialog(status: string) {
    // this._dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(status); }, 1000);
  }
  /* --------------------------------- GETTERS --------------------------------- */
  get supplier_id() {
    return this.supplierAccountRequestPayForm.get('supplier_id')
  }
  get name() {
    return this.supplierAccountRequestPayForm.get('name')
  }
  get email() {
    return this.supplierAccountRequestPayForm.get('email')
  }
  get phone() {
    return this.supplierAccountRequestPayForm.get('phone')
  }

  /* --------------------------- Add Update Account --------------------------- */
  async addUpdateSupplierAccount(){
    if(this.supplierAccountRequestPayForm.invalid){
      this.toast.openSnackBar('Please enter valid details');
      this.supplierAccountRequestPayForm.markAllAsTouched();
      return;
    }
    this.spinner.show();
    try{
      const supplierAccount = this.supplierAccountRequestPayForm.value as any;
      await this.addSupplierAccountRequestService.addSupplierAccountRequest(supplierAccount);
      this.spinner.hide();
      this.toast.openSnackBar('Account details saved successfully');
      this.closeDialog('yes');
    } catch(error) {
      this.spinner.hide();
      this.toast.openSnackBar('Unable to save account details');
    }
  }
}
